import React, { useContext } from "react"; // Asegúrate de importar useContext
import { Navigate } from "react-router-dom";
import AppContext from "../pages/vocacional/AppContext"; // Ruta correcta al archivo AppContext

const ProtectedRoute = ({ children }) => {
  const { isFormCompleted } = useContext(AppContext); // Usa useContext para acceder al valor del contexto

  // Si el formulario no está completo, redirige a /vocacional
  if (!isFormCompleted) {
    return <Navigate to="/vocacional" replace />;
  }

  return children; // Renderiza el contenido protegido
};

export default ProtectedRoute;
